<template>
  <div class="min-h-screen bg-background-light">
    <header class="fixed top-0 left-0 right-0 z-50 bg-white border-b border-primary/10">
      <div class="max-w-7xl mx-auto px-6 lg:px-20 h-16 flex items-center justify-between">
        <RouterLink class="flex items-center gap-3" to="/">
          <div class="size-10 bg-primary flex items-center justify-center rounded-xl text-white">
            <span class="material-symbols-outlined text-2xl">local_shipping</span>
          </div>
          <h2 class="text-primary text-lg font-black tracking-tight uppercase">Guépard Express</h2>
        </RouterLink>
        <RouterLink class="text-sm font-bold text-primary" to="/">Retour au site</RouterLink>
      </div>
    </header>

    <div class="pt-20">
      <div class="max-w-7xl mx-auto px-6 lg:px-20 py-10">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          <div class="space-y-6">
            <h1 class="text-4xl font-black tracking-tight text-slate-900">Connexion</h1>
            <p class="text-slate-600 font-medium">
              Accédez à votre portail pour créer vos expéditions, comparer les transporteurs et suivre vos colis.
            </p>
            <div class="rounded-2xl border border-primary/10 bg-white p-6">
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div class="rounded-xl bg-background-light/60 border border-primary/10 p-4">
                  <div class="size-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                    <span class="material-symbols-outlined">sell</span>
                  </div>
                  <div class="mt-3 font-black">Tarifs</div>
                  <div class="text-sm text-slate-600 font-medium">Comparaison instantanée</div>
                </div>
                <div class="rounded-xl bg-background-light/60 border border-primary/10 p-4">
                  <div class="size-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                    <span class="material-symbols-outlined">receipt_long</span>
                  </div>
                  <div class="mt-3 font-black">Étiquettes</div>
                  <div class="text-sm text-slate-600 font-medium">Téléchargement PDF</div>
                </div>
                <div class="rounded-xl bg-background-light/60 border border-primary/10 p-4">
                  <div class="size-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center">
                    <span class="material-symbols-outlined">travel_explore</span>
                  </div>
                  <div class="mt-3 font-black">Suivi</div>
                  <div class="text-sm text-slate-600 font-medium">Statuts en temps réel</div>
                </div>
              </div>
            </div>
          </div>

          <div class="rounded-2xl border border-primary/10 bg-white p-8">
            <form class="space-y-5" @submit.prevent="onSubmit">
              <div>
                <label class="block text-sm font-bold text-slate-700">Identifiant</label>
                <input
                  v-model.trim="login"
                  class="mt-2 h-12 w-full rounded-xl border border-primary/15 bg-white px-4 text-sm font-semibold outline-none focus:border-primary focus:ring-4 focus:ring-primary/10"
                  placeholder="Email ou téléphone"
                  type="text"
                />
              </div>
              <div>
                <label class="block text-sm font-bold text-slate-700">Mot de passe</label>
                <input
                  v-model="password"
                  class="mt-2 h-12 w-full rounded-xl border border-primary/15 bg-white px-4 text-sm font-semibold outline-none focus:border-primary focus:ring-4 focus:ring-primary/10"
                  placeholder="••••••••"
                  type="password"
                />
              </div>

              <div v-if="error" class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm font-semibold text-red-700">
                {{ error }}
              </div>

              <button
                class="w-full h-12 rounded-xl bg-primary text-white font-black shadow-lg shadow-primary/20 disabled:opacity-60"
                :disabled="loading"
                type="submit"
              >
                {{ loading ? 'Connexion…' : 'Se connecter' }}
              </button>

              <div class="text-xs text-slate-500 font-medium">
                <!-- Backend Laravel : http://127.0.0.1:8000/api/login -->
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth'

export default {
  name: 'LoginPage',
  data() {
    return {
      login: '',
      password: '',
      error: null
    }
  },
  computed: {
    auth() {
      return useAuthStore()
    },
    loading() {
      return this.auth.loading
    }
  },
  methods: {
    async onSubmit() {
      this.error = null
      try {
        await this.auth.login({ login: this.login, password: this.password })
        this.$router.push('/app/dashboard')
      } catch (e) {
        this.error = this.auth.error || 'Erreur de connexion'
      }
    }
  }
}
</script>
